import * as React from 'react';
import cn from 'clsx';
import { RadioButtonGroup, UiKitRoot } from '@cian/ui-kit';

import { ErrorPopover } from '../ErrorPopover';
import { sortRoomsCount } from './utils';
import { TRoomsCountSelectorComponentProps } from '../../utils/types';

import * as styles from './styles.css';

export function RoomsCountSelector(props: TRoomsCountSelectorComponentProps) {
  const { errorMessage, value, className, onValueChange, values } = props;
  const valuesList = React.useMemo(() => sortRoomsCount(Object.values(values)), [values]);

  return (
    <UiKitRoot deviceType="phone" useStaticDeviceType>
      <ErrorPopover tooltipContent={errorMessage || ''}>
        <div className={cn(styles['container'], className)} data-name="roomsCount_filter">
          <RadioButtonGroup
            value={value || undefined}
            options={valuesList}
            onChange={(_, value) => onValueChange(value)}
          />
        </div>
      </ErrorPopover>
    </UiKitRoot>
  );
}
